// extracted by mini-css-extract-plugin
export default {"personDetails":"PersonDetails-module__personDetails___xcX1N","title":"PersonDetails-module__title___PVjCX","subtitle":"PersonDetails-module__subtitle___DX45Z"};